import { render } from "./TvmCurrentVehicle.vue?vue&type=template&id=e27c719c&scoped=true"
import script from "./TvmCurrentVehicle.vue?vue&type=script&lang=js"
export * from "./TvmCurrentVehicle.vue?vue&type=script&lang=js"

import "./TvmCurrentVehicle.vue?vue&type=style&index=0&id=e27c719c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e27c719c"]])

export default __exports__